import { useState } from "react";
import { Languages, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

const COMMON_LANGS = [
  { code: "es", name: "Spanish" },
  { code: "ht", name: "Haitian Creole" },
  { code: "fr", name: "French" },
  { code: "pt", name: "Portuguese" },
];

export default function TranslateToggle({ enabled, currentText, onTranslated, onLockClick }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(null);

  async function translate(code) {
    if (!enabled) {
      if (onLockClick) onLockClick();
      else toast.info("This is part of the AI Messaging Assistant add-on ($49/mo).");
      return;
    }
    if (!currentText.trim()) {
      toast.info("Type your reply in English first, then translate.");
      return;
    }
    setBusy(code);
    try {
      const r = await api.post("/messages/ai/translate", {
        text: currentText, target_language: code,
      });
      onTranslated(r.data.translated);
      toast.success(`Translated to ${r.data.target_name}`);
      setOpen(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Translation failed");
    } finally {
      setBusy(null);
    }
  }

  return (
    <div className="relative">
      <button
        type="button"
        data-testid="ai-translate-btn"
        onClick={() => (enabled ? setOpen(!open) : translate("es"))}
        className={`flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-md transition-colors ${enabled ? "bg-[#D6E0D9]/40 text-[#2E5C50] hover:bg-[#D6E0D9]/70" : "bg-[#F0EDE8] text-[#57605A] hover:bg-[#E8E6E1]"}`}
        title={enabled ? "Translate your reply" : "Add AI Messaging Assistant ($49/mo) to unlock"}
      >
        {enabled ? <Languages className="w-3.5 h-3.5" strokeWidth={1.5} /> : <Lock className="w-3.5 h-3.5" strokeWidth={1.5} />}
        Translate
      </button>
      {open && enabled && (
        <div
          data-testid="translate-menu"
          className="absolute right-0 mt-2 bg-white border border-[#E8E6E1] rounded-md shadow-lg overflow-hidden z-20 min-w-[180px]"
        >
          {COMMON_LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              data-testid={`translate-to-${l.code}`}
              disabled={busy === l.code}
              onClick={() => translate(l.code)}
              className="w-full text-left px-3 py-2 text-sm hover:bg-[#F9F7F4] flex items-center justify-between border-b border-[#F0EDE8] last:border-0"
            >
              {l.name}
              {busy === l.code && <Loader2 className="w-3 h-3 animate-spin text-[#2E5C50]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
